// Which required questions can hold up a step's button, as in the app
// (mobileapp editable_form/requiredAnswers.js). Only those the person can answer
// on the screen as it is: a question with nothing left to choose (every option
// hidden or sold out) would otherwise keep the form from ever being sent. These
// rules mirror what EditableForm lets each row do on the web.
import { isAutoPaymentMethod, webPaymentMethodOptions } from './autoPaymentMethod';

const OPTION_TYPES = new Set(['multiple-choice', 'checkbox']);

export const canAnswerElement = (element, { formValues = {}, remainingTickets = {} } = {}) => {
  const options = element?.content?.options || [];
  if (isAutoPaymentMethod(element)) return webPaymentMethodOptions(element, formValues[element.id]).length > 0;
  if (OPTION_TYPES.has(element?.type)) return options.length > 0;
  const taken = (index) => (formValues[element.id]?.[index] || 0) > 0;
  const soldOut = (index) => remainingTickets?.[`${element.id}_${index}`] <= 0;
  if (element.type === 'ticket-v2-single') {
    return options.some((option, index) => !option?.hidden && (taken(index) || !(option?.limit && soldOut(index))));
  }
  if (element.type === 'ticket-v2') {
    // "+" works until the option is known to be sold out
    return options.some((option, index) => !option?.hidden && (taken(index) || !soldOut(index)));
  }
  if (element.type === 'ticket') {
    // "Sí" (index 0) can sell out; any other option ("No") is always there
    return options.length > 1 || (options.length === 1 && (!(element.limit && soldOut(0)) || formValues[element.id] === 0));
  }
  return true;
};

// The first one, in the order the screen shows them, that is still unanswered
export const firstMissingElement = (elements, errors) =>
  elements.find((element) => element && Object.prototype.hasOwnProperty.call(errors, element.id)) || null;
